import {actions} from 'react-fields'

class InvitationsApi {

    static sendInvitations(emails) {
        const url = '/group/api/invitations';
        let data = {emails: emails};

        return fetch(actions.postRequest(url, data))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            })
    }

    static resend(user_id) {
        const url = `/group/api/invitations/${user_id}/resend`;

        return fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            })
    }


}

export default InvitationsApi;